import type { Server, ServerForm } from "@/app/servers/types";
import type { ApiClient } from "@/lib/api";

export const createServer = async (options: {
  client: ApiClient;
  server: ServerForm;
}) => {
  const { client, server } = options;
  const { data } = await client.post<Server>("/workers", server);
  return data;
};
